import isDuitangImage from './isDuitangImage';

/**
 * @description 去掉webp后缀
 * @param url 图片地址
 * @returns 处理后的图片地址
 */
const dtImageNoWebp = (url: string): string => {
  if (isDuitangImage(url)) {
    if (url.endsWith('_webp')) {
      return url.replace(/_webp$/, '');
    }
  }
  return url;
};
export default dtImageNoWebp;
